module.exports = __webpack_public_path__ + "img/ACEITESESCENCIALES.6bb93681.png";